/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-03-14 16:50:38
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-14 21:05:57
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/product/selectModelGroup.tsx
 * @Description: default
 */
import { Fragment } from "react";
import { CN_PRODUCT } from "@/utils/const";
import Image, { StaticImageData } from "next/image";
import { TEST_IMAGE } from "./const";
import FLASH_SALE_ICON from "@/images/icon/flash-sale.png";
import SkuCoupon from "./skuCoupon";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
// styles
import { SelectModelGroupWrapper } from "@/styles/product";
import { AttrUtils, ButtonPartVo, ColorSizePartVo } from "@/utils/attrUtils";
import CDNImage from "../cdnImage/cdnImage";
import SafeLink from "@/components/SafeLink";
import { formatProductLink } from "@/common-components-src/js/server";
const colorSizePartListAddCheckedAttr = (colorSizePartList: ColorSizePartVo[], skuId: string) => {
  // console.log(JSON.stringify(colorSizePartList));
  // 给每一个buttonPart选项添加是否被选中的属性
  for (const colorSizePart of colorSizePartList) {
    for (const buttonPart of colorSizePart.buttonPartList || []) {
      buttonPart.checked = buttonPart.skuList?.includes(skuId) || false;
    }
  }
  // 给每一个buttonPart选项添加点击之后跳转的目标skuid
  for (const [dimensionIndex, colorSizePart] of colorSizePartList.entries()) {
    for (const buttonPart of colorSizePart.buttonPartList || []) {
      const otherDimensionSkuids = colorSizePartList
        .filter((v, i) => dimensionIndex !== i)
        .map((v) => v.buttonPartList)
        .flat()
        .filter((b) => b?.checked)
        .map((v) => v?.skuList)
        .filter((v) => v !== undefined);

      buttonPart.targetSkuId = AttrUtils.getSkuIntersect([...otherDimensionSkuids, buttonPart.skuList || []])?.[0];
    }
  }
};

export default function SelectModelGroup({ floors, spuTitle }: any) {
  const productSelectedFloor = floors.productSelectedFloor?.data;
  const productSeriesFloor = floors.productSeriesFloor?.data;
  const colorSizePartList: ColorSizePartVo[] = (productSelectedFloor?.colorSizePartList || []).map((v: any) => ({
    ...v["C-P#dimension&dimension"],
    buttonPartList: v.buttonPartList.map((k: any) => ({ ...k["C-P#dimensionButton&dimensionButton"] })),
  }));
  const skuId = floors?.productDetailFloor?.data?.productDetailReqParam?.skuId;
  colorSizePartListAddCheckedAttr(colorSizePartList, skuId);
  // console.log(JSON.stringify(colorSizePartList));

  const getSelectPartText = (parts: ButtonPartVo[]) => {
    let partText: string = "";
    parts.forEach((part: ButtonPartVo) => {
      if (part.checked) {
        partText = part.text as string;
      }
    });
    return partText;
  }

  const {seriesGroupName, widthSeletedSeries } = productSeriesFloor?.series?.reduce((prev: any, next: any) => {
    if(next?.skus?.includes(skuId)){
      prev.seriesGroupName = next.name;
      prev.widthSeletedSeries = [...(prev.widthSeletedSeries || []), {...next, checked: true}];
    } else {
      prev.widthSeletedSeries = [...(prev.widthSeletedSeries || []), {...next, checked: false}];
    }
    return prev;
  }, {}) || {}

  return (
    <SelectModelGroupWrapper>
      {productSeriesFloor?.series && <div
          className="group"
          key={100}
          exptag={"exp|" + EXPOSURE_RECORD.Productdetail_Specification_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({
            mainskuid: skuId,
            specificationType: "Series"
          })}
        >
          <div className="head">Series:<span>{seriesGroupName}</span></div>
          <div className="content">
            {widthSeletedSeries?.map((b: any) => {
              return (
                <SafeLink
                  key={b.id}
                  href={formatProductLink(b.skus?.[0])}
                >
                  <div className={`item text ${b.checked ? 'active': ''}`}>
                    {b.name}
                  </div>
                </SafeLink>
              )
            })}
          </div>
      </div>}
      {colorSizePartList.map((v, index) => (
        <div
          className="group"
          key={v.dimensionNumber}
          exptag={"exp|" + EXPOSURE_RECORD.Productdetail_Specification_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({
            mainskuid: skuId,
            specificationType: v.dimTitle,
          })}
        >
          <div className="head">
            {v.dimTitle}
            <span>{`: ${getSelectPartText(v.buttonPartList as ButtonPartVo[])}`}</span>
          </div>
          <div className="content">
            {v.buttonPartList &&
              v.buttonPartList.map((b) => {
                const zone = b.imgUrl ? (
                    <div className={`item imgV1 ${b.targetSkuId ? "" : "disabled"} ${b.checked ? "active" : ""}`} key={b.skuList?.join("")}>
                      <CDNImage src={b.imgUrl as string} width={60} height={60} alt="image" />
                      <div className="skuName">{b.text}</div>
                    </div>
                ) : (
                  <div className={`item text ${b.targetSkuId ? "" : "disabled"} ${b.checked ? "active" : ""}`} key={b.skuList?.join("")}>
                    {b.text}
                  </div>
                );
                return (
                  <Fragment key={b.skuList?.join("")}>
                    {b.targetSkuId ? (
                      <SafeLink
                        href={formatProductLink(b.targetSkuId)}
                        trackClickParams={{
                          event_id: "Productdetail_Click",
                          json_param: {
                            mainskuid: skuId,
                            specificationType: v.dimTitle,
                          },
                        }}
                      >
                        {zone}
                      </SafeLink>
                    ) : (
                      zone
                    )}
                  </Fragment>
                );
                p;
              })}
          </div>
        </div>
      ))}
    </SelectModelGroupWrapper>
  );
}
